import { useEffect } from "react";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import HeroSection from "./components/HeroSection";
import CategoryHub from "./components/CategoryHub";
import WhatIsSection from "./components/WhatIsSection";
import WhyUseSection from "./components/WhyUseSection";
import PopularCategoriesSection from "./components/PopularCategoriesSection";
import ComparisonSection from "./components/ComparisonSection";
import SafetySection from "./components/SafetySection";
import ArticleSection from "./components/ArticleSection";
import FAQSection from "./components/FAQSection";
import CTASection from "./components/CTASection";

const siteUrl = "https://kakobuyfinds.cyou";

const organizationSchema = {
  "@context": "https://schema.org",
  "@type": "Organization",
  "name": "KakobuyFinds",
  "url": siteUrl,
  "description": "Kakobuy Spreadsheet Polska – największa baza produktów i finds dla polskich kupujących. Aktualne listy produktów, przewodniki zakupowe, porównania i bezpieczne wskazówki.",
  "inLanguage": "pl-PL",
  "foundingDate": "2025",
  "areaServed": {
    "@type": "Country",
    "name": "Polska"
  }
};

const websiteSchema = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  "name": "KakobuyFinds",
  "url": siteUrl,
  "description": "Kakobuy Spreadsheet Polska – najlepsze finds, linki produktów i aktualne listy 2026. Odkryj zweryfikowane produkty i przewodniki zakupowe.",
  "inLanguage": "pl-PL",
  "potentialAction": {
    "@type": "SearchAction",
    "target": `${siteUrl}/search?q={search_term_string}`,
    "query-input": "required name=search_term_string"
  }
};

export default function Home() {
  useEffect(() => {
    const orgScript = document.createElement("script");
    orgScript.type = "application/ld+json";
    orgScript.textContent = JSON.stringify(organizationSchema);
    document.head.appendChild(orgScript);

    const webScript = document.createElement("script");
    webScript.type = "application/ld+json";
    webScript.textContent = JSON.stringify(websiteSchema);
    document.head.appendChild(webScript);

    return () => {
      if (orgScript.parentNode) orgScript.parentNode.removeChild(orgScript);
      if (webScript.parentNode) webScript.parentNode.removeChild(webScript);
    };
  }, []);

  return (
    <>
      <Navbar />
      <main>
        <HeroSection />
        <WhatIsSection />
        <WhyUseSection />
        <CategoryHub />
        <PopularCategoriesSection />
        <ComparisonSection />
        <SafetySection />
        <CTASection />
        <ArticleSection />
        <FAQSection />
      </main>
      <Footer />
    </>
  );
}